import React from "react";
import styled from "styled-components";

const Header = ({ score }) => {
  return (
    <HeaderStyled>
      <h1>
        ROCK <br />
        PAPER <br />
        SCISSORS
      </h1>
      <Score>
        <span>SCORE</span>
        <p>{score}</p>
      </Score>
    </HeaderStyled>
  );
};

export default Header;

const HeaderStyled = styled.div`
  border: 3px solid rgba(255, 255, 255, 0.2);
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  h1 {
    font-size: 1.5rem;
    line-height: 1.2rem;
    color: white;
  }

  @media screen and (min-width: 1024px) {
    padding: 1.5rem;
    h1 {
      font-size: 2rem;
      line-height: 1.5rem;
    }
  }
`;

const Score = styled.div`
  background-color: white;
  border-radius: 5px;
  padding: 0.25rem 1.2rem;
  text-align: center;
  span {
    color: hsl(229, 64%, 46%);
    font-size: 0.7rem;
    letter-spacing: 0.1rem;
  }
  p {
    font-size: 2.5rem;
  }

  @media screen and (min-width: 1024px) {
    padding: 0.5rem 1.5rem;
  }
`;
